import { PropsWithChildren, ReactElement } from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

// Types
type IProps = PropsWithChildren<{
  headingText?: string;
}>;

export const NoResultsCard = (props: IProps): ReactElement => {
  const { children, headingText } = props;

  return (
    <Container>
      <Box sx={{ m: 3, mt: 5 }}>
        <Paper sx={{ height: '50vh' }}>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            {headingText && <h2>{headingText}</h2>}
            {children || <Typography>No Results</Typography>}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};
